import {
    createContext,
    ReactElement,
    useMemo,
    useState,
  } from 'react';
  
  export const WebContext = createContext<any>('');
  
  interface WebContextProviderProps {
    children: ReactElement | ReactElement[];
  }
  
  export const WebContextProvider = (props: WebContextProviderProps) => {
    const { children } = props;
    const [webContent, setWebContent] = useState<any>('');
    const [tcpaData, setTcpaData] = useState<any>('');
    const leadValues = useMemo(
      () => ({
        webContent,
        setWebContent,
        tcpaData,
        setTcpaData,
      }),
      [webContent,tcpaData]
    );
  
    return (
      <WebContext.Provider value={leadValues}>{children}</WebContext.Provider>
    );
  };
  